/** Runtime config injected at build / via window or env. */
export type AppConfig = {
  apiBaseUrl: string;
  cognitoUserPoolId: string;
  cognitoClientId: string;
  cognitoRegion: string;
};

declare global {
  interface Window {
    __SUPPORTO_CONFIG__?: Partial<AppConfig>;
  }
}

export function getConfig(): AppConfig {
  const w = typeof window !== 'undefined' ? window.__SUPPORTO_CONFIG__ : undefined;
  const pick = (v: string | undefined, fallback: string) => {
    if (!v || v.startsWith('REPLACE_')) return fallback;
    return v;
  };
  return {
    apiBaseUrl: pick(
      w?.apiBaseUrl,
      import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:3001',
    ),
    cognitoUserPoolId: pick(
      w?.cognitoUserPoolId,
      import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    ),
    cognitoClientId: pick(
      w?.cognitoClientId,
      import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    ),
    cognitoRegion: pick(
      w?.cognitoRegion,
      import.meta.env.VITE_COGNITO_REGION || 'eu-west-1',
    ),
  };
}
